import { Button, Modal } from "semantic-ui-react";

const ParentResourceAlertModal = ({ parentResourceAlertModalState, setParentResourceAlertModalState }) => {
    const modalClose = () => {
        setParentResourceAlertModalState({ modalOpen: false }); //, parentResourcesToBeAlertedTo: undefined
    }
    let parentResourcesToBeAlertedTo = parentResourceAlertModalState.parentResourcesToBeAlertedTo;
    let modalContent = <div style={{
        paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "10px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <div style={{ float: "left" }}>
            <Button className="formButton negative"
                style={{ padding: "6px", position: "absolute", right: "14px", zIndex: "10" }} content="✖" title="Close"
                onClick={() => { modalClose(); }}
            />
            <h1>Resource Updated</h1>
            {parentResourcesToBeAlertedTo?.length === 1 ?
                <>
                    <h2>
                        You are following a Resource that references this updated resource.
                        Update the following Resource if you need to account for the changes you've made.
                    </h2>
                    <h3><a href={"/resources/" + parentResourcesToBeAlertedTo[0].subtype[0] + "/" + parentResourcesToBeAlertedTo[0].id} target="_blank" rel="noopener noreferrer">{parentResourcesToBeAlertedTo[0].title}</a></h3>
                    <span>
                        {/*
            <Button className="formButton" content="Go to parent resource" title="Close" onClick={() => { modalClose(); }} />
            &nbsp;&nbsp;&nbsp;
            */}
                    </span>
                </>
                :   //Multiple parent resources
                <>
                    <h2>
                        You are following these Resources that reference this updated resource.
                        Update these Resources if you need to account for the changes you've made.
                    </h2>
                    {parentResourcesToBeAlertedTo?.map((parentResource, index) => {
                        return <div key={index} style={{ marginTop: "8px" }}>
                            <h4><a href={"/resources/" + parentResource.subtype[0] + "/" + parentResource.id} target="_blank" rel="noopener noreferrer">{parentResource.title}</a></h4>
                        </div>
                    })}
                </>
            }
            <br />
            <br />
            <Button className="formButton" content="Close" title="Close" onClick={() => { modalClose(); }} />
        </div>
        <br />
    </div>;

    return <Modal
        style={{ padding: "0px", margin: "0px" }}
        dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
        open={true}
        centered={false}
        content={modalContent}
    />
}

export default ParentResourceAlertModal;